<script setup lang="ts">
import { computed } from 'vue'
import { ICON_PATHS, type IconName } from '../icons'

// Decorative by default; pass `label` for icon-only meaning.
const props = withDefaults(defineProps<{ name: IconName; size?: number; strokeWidth?: number; label?: string }>(), {
  size: 20,
  strokeWidth: 1.75,
  label: undefined,
})

const markup = computed(() => ICON_PATHS[props.name])
</script>

<template>
  <!-- Markup comes only from the ICON_PATHS constants, never from data. -->
  <!-- eslint-disable vue/no-v-html -->
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    :stroke-width="strokeWidth"
    stroke-linecap="round"
    stroke-linejoin="round"
    :role="label ? 'img' : undefined"
    :aria-label="label"
    :aria-hidden="label ? undefined : 'true'"
    class="ui-icon"
    v-html="markup"
  ></svg>
</template>

<style scoped>
.ui-icon {
  flex-shrink: 0;
}
</style>
